module.exports = " <div class=item-rate> <input type=hidden class=rating data-filled=\"fa fa-star item-rate-yellow item-rate\" data-empty=\"fa fa-star item-rate-gray item-rate\" data-readonly :value=render_rating /> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/Product-detail-rate-stars.vue
// module id = 555
// module chunks = 0